import { Asset, Container } from '@integration-frontends/integration/core/model';

export const SHARING_SERVICE_TOKEN = 'SHARING_SERVICE';

export interface ISharingService {
  getAssetShareUrl(container: Container, asset: Asset): Promise<string>;
}
